import { GiftVoucherField, VoucherDeliveryMethod } from '@big-red-group/storefront-common-checkout'

export const defaultVoucherFields: GiftVoucherField[] = [
  {
    name: 'gift_to',
    key: 'TO',
    title: 'To',
    placeholder: 'e.g. Mum & Dad.',
    type: 'TEXT',
    required: true,
    minLength: 1,
    maxLength: 50,
    order: 0,
  },
  {
    name: 'gift_message',
    key: 'MESSAGE',
    title: 'Message',
    placeholder: 'Thanks for everything - enjoy this epic experience!',
    type: 'LONGTEXT',
    required: true,
    minLength: 1,
    maxLength: 150,
    order: 1,
  },
  {
    name: 'gift_from',
    key: 'FROM',
    title: 'From',
    placeholder: 'e.g. Bridget',
    type: 'TEXT',
    required: true,
    minLength: 1,
    maxLength: 50,
    order: 2,
  },
]

export const defaultVoucherDeliveryMethods: VoucherDeliveryMethod[] = [
  {
    key: 'ELECTRONIC',
    label: 'Electronic',
    requiresPhysicalAddress: false,
    amount: 0,
    currencyCode: 'AUD',
    default: false,
  },
  {
    key: 'ADR_EXPRESS_POST',
    label: 'Express Post',
    requiresPhysicalAddress: true,
    amount: 1500,
    currencyCode: 'AUD',
    default: true,
  },
  {
    key: 'ADR_STANDARD_POST',
    label: 'Standard Post',
    requiresPhysicalAddress: true,
    amount: 750,
    currencyCode: 'AUD',
    default: false,
  },
]

export const redemptionFaqs = [
  {
    heading: 'What is an Experience Oz gift voucher?',
    content:
      '<p>Gift complete freedom to choose the next activity, attraction or tour with an Experience Oz Gift Voucher. You can use a gift voucher to book any experience on Experience Oz, making it the perfect gift for any occasion or just because.</p><p>Experience Oz Gift Vouchers are sent instantly by email.</p>',
  },
  {
    heading: 'How can I find my gift voucher details?',
    content:
      'If you have been sent a gift voucher it can be found in your inbox by searching via our email send address "no_reply@experienceoz.com.au" or with the keywords "Experience Oz Voucher." In the corresponding email there will be a link to your digital gift voucher that contains the gift voucher Number and PIN. You can then copy and paste the Number and PIN to the fields on this page.',
  },
  {
    heading: 'How to use an Experience Oz gift voucher?',
    content:
      '<p>After receiving an Experience Oz gift voucher simply enter the gift voucher number and PIN above. You will be asked to add to a new or existing account to link the gift voucher as account credit</p><p>Once you have added your Experience Oz gift voucher to your account simply find your next awesome adventure and Add to Cart. On the Checkout Page you will see your account credit that you can use towards your next adventure.</p>',
  },
  {
    heading: 'When does my Experience Oz gift voucher expire?',
    content: 'Experience Oz gift vouchers have a 5 year expiry.',
  },
  {
    heading: 'I have other questions',
    content:
      "Having trouble with your gift voucher or have any other questions? Visit our <a href='/en/faqs'>Help Centre</a> or jump on Live Chat by clicking on the 'Chat with an Expert' button in the bottom-left of the screen to speak with our Customer Experience Team.",
  },
]

export const giftVoucherFaqs = [
  {
    heading: 'What is an Experience Oz gift voucher?',
    content:
      '<p>Gift complete freedom to choose the next activity, attraction or tour with an Experience Oz gift voucher. You can use a gift voucher to book any experience on Experience Oz, making it the perfect gift for any occasion or just because.</p><p>Experience Oz gift vouchers are sent instantly by email.</p>',
  },
  {
    heading: 'How to send an Experience Oz gift voucher?',
    content:
      '<p>Select your preferred gift voucher theme and chosen value. Personalise by adding the To, From and Message that will show on the gift voucher. Choose to send instantly by email or make it special by posting a physical gift voucher.</p>',
  },
  {
    heading: 'How can I find my gift voucher details?',
    content:
      'If your gift voucher was sent via email you can find it by searching via our email send address "no_reply@experienceoz.com.au" or with the keywords "Experience Oz Voucher." In the corresponding email there will be a link to your digital gift voucher that contains the gift voucher number and PIN. You can then copy and paste the number and PIN to the fields on the <a href="/en/redeem">Redeem Page</a>.',
  },
  {
    heading: 'How to use an Experience Oz gift voucher?',
    content:
      '<p>After receiving an Experience Oz gift voucher simply go to the <a href="/en/redeem">Redeem Page</a> and enter the gift voucher number and PIN. You will be asked to add to a new or existing account to link the gift voucher.</p><p>Once you have added your gift voucher to your account simply find your next experience and book. On the Checkout Page you will see your account credit that you can use towards your next experience.</p>',
  },
  {
    heading: 'How to check Experience Oz gift voucher balance?',
    content:
      'To check your Experience Oz gift voucher balance simply go to the Redeem Page. If you have already linked your gift voucher you can find your balance on your Account.',
  },
  {
    heading: 'When does my Experience Oz gift voucher expire?',
    content: 'Experience Oz gift vouchers have a 5 year expiry.',
  },
  {
    heading: 'I have other questions',
    content:
      "Having trouble with your gift voucher or have any other questions? Visit our <a href='/en/faqs'>Help Centre</a> or jump on Live Chat by clicking on the 'Chat With Us' button in the bottom-right of the screen to speak with our Customer Experience Team.",
  },
]

export const sessionVouchersKey = 'addedVouchers'
